import { Directive, HostListener, ElementRef, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAppMovementAction]'
})
export class AppMovementActionDirective {

  regExp = (/[a-zA-Z\u00f1\u00d1]/);

  constructor(@Self() private ngControl: NgControl, private element: ElementRef) { }


  @HostListener('keypress', ['$event']) onKeyPress(evento: KeyboardEvent): boolean {
    const tecla = evento.key;
    const valor: string = this.element.nativeElement.value;
    if (!this.regExp.test(tecla)) {
      this.ngControl.control.setValue(valor);
      return false;
    }
  }

  @HostListener('change') onChange(): void {
    const value: string = this.element.nativeElement.value;
    this.ngControl.control.setValue(value.toUpperCase());
  }

}
